import { Persona } from '@localStorage/domain/models/Persona'
import { User } from '@localStorage/domain/models/User'

import {
  LocalStorage,
  localStorageDatasource,
  localStorageRepositoryAdapter
} from '@/modules/localStorage'

import axios from '../helpers/axios'

const localStorage = LocalStorage(
  localStorageRepositoryAdapter(localStorageDatasource)
)

export default class AuthService {
  private constructor() {
    throw new Error('Cannot be instantiated')
  }

  static logout(): void {
    localStorage.deleteUser()
    localStorage.deletePersona()
    localStorage.clear()
  }

  static getUser() {
    return localStorage.getUser()
  }

  static setUser(newSessionData: Partial<User>) {
    const user = localStorage.getUser()
    if (!user) return

    if (newSessionData.accessToken)
      axios.defaults.headers.common.Authorization =
        'Bearer ' + newSessionData.accessToken
    localStorage.setUser({ ...user, ...newSessionData })
  }

  static getPersona() {
    return localStorage.getPersona()
  }

  static setPersonaByID(id: string) {
    const user = this.getUser()
    if (!user) return
    const persona = user.personaAuthenticationResponses.find(
      ({ personaId }) => personaId === id
    )
    if (!persona) return
    axios.defaults.headers.common['X-CompanyID'] = persona.companyId
    localStorage.setPersona(persona)
  }

  static setPersona(newPersonaData: Partial<Persona>) {
    const persona = localStorage.getPersona()
    if (!persona) return
    localStorage.setPersona({ ...persona, ...newPersonaData })
  }
}
